<template>
	<div class="order">
		<back-to :title="orderList.nearTravelName" :orderby="true"></back-to>
		<!-- 订单信息 -->
		<section class="orderInfo orderCommon">
			<h2>{{orderList.nearTravelName}}</h2>
			<span>
				<p>套餐类型:</p>
				<font>{{orderList.skuName}}</font>
			</span>
			<span>
				<p>出行日期:</p>
				<font>{{orderList.salesDate}}</font>
			</span>
			<span>
				<p>有效日期:</p>
				<font>{{orderList.expiryDate}}</font>
			</span>

		</section>
		<!-- 购买数量 -->
		<section class="orderNum orderCommon">
			<span class="orderNum-t">
				<p>数量</p>
				<p>{{param.number}}</p>
			</span>
			<span class="orderNum-x" @click="show = true">购买须知</span>
		</section>
		<!-- 出行人 -->
		<section class="orderTravel orderCommon" v-if="orderList.isTraveler">
			<h2>出行人信息</h2>
			<div class="orderTravel-p">
				<span>可添加<p>{{param.number}}个</p>出行人</span>
				<span @click="travelerShow = true">添加出行人</span>
			</div>
			<div class="orderTravel-c">
				<ul>
					<li v-for="(item,index) in selectTravelerList" :key="index">
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_03.png"
							@click="selectTravelersD(index)" alt="">
						<!-- <p>{{item.templatTag[0].tagValue}}</p>
						<p>{{item.templatTag[1].tagValue}}</p> -->
						<p v-for="(map,sort) in item.templatTag" :key="sort" v-if="map.isMain">{{map.tagValue}}</p>
					</li>
				</ul>
			</div>
		</section>
		<!-- 联系人信息 -->
		<section class="orderContact orderCommon">
			<h2>联系人信息</h2>
			<div class="contact_mes">
				<p>联系人</p>
				<font @click="orderContactShow = true">选择联系人</font>
			</div>
			<div class="orderContact-text">
				<van-field v-model="getTicketName" label="姓名" placeholder="请输入证件上的实际姓名" />
				<van-field v-model="getTicketTel" type="tel" label="手机号" placeholder="请输入手机号用于接收短信" />
			</div>
		</section>
		<!-- 优惠 -->
		<section class="orderSale orderCommon">
			<h2>优惠</h2>
			<div class="orderSale-sale">
				<p>优惠券</p>
				<span class="coupon-value" @click="orderSaleshow = true">
					<p class="coupon-price">{{select_coupon==null?'请选择优惠券':select_coupon.name}}</p>
					<p class="coupon-sign">></p>
				</span>
			</div>
		</section>
		<!-- 留言 -->
		<section class="orderMessage orderCommon">
			<h2>备注(选填)</h2>
			<div class="orderMessage-remark">
				<van-field v-model="remark" type="textarea" maxlength="100" placeholder="额外要求可以写在这里" show-word-limit />
			</div>
		</section>
		<section class="orderBottom">
			<span>￥{{select_coupon==null?param.payMoney:select_coupon.useCouponPrice}}</span>
			<span @click="submitOrder">提交订单</span>
		</section>
		<!-- 购买须知 -->
		<van-popup class="orderPopup" v-model="show" round position="bottom">
			<h2 class="alertTitle">购买须知</h2>
			<div class="popup">
				<span class="popup_title_1">
					<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_04.png" alt="">
					<p>费用包含</p>
				</span>
				<span class="orderPopup-text">{{expenseInclude}}</span>
			</div>
			<div class="popup">
				<span class="popup_title_1 color01">
					<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_05.png" alt="">
					<p>费用不包含</p>
				</span>
				<span class="orderPopup-text">{{expenseNotInclude}}</span>
			</div>
			<div class="popup">
				<span class="popup_title_1 color02">
					<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_06.png" alt="">
					<p>使用须知</p>
				</span>
				<span class="orderPopup-text">{{added}}</span>
			</div>
		</van-popup>
		<!-- 出行人信息 -->
		<van-popup class="orderPopupt" v-model="travelerShow" round position="bottom" @click-overlay="travelerCancel">
			<div class="orderPopup-sure">
				<span @click="travelerCancel">取消</span>
				<span @click="travelerTrue">确认</span>
			</div>
			<div class="orderPopup-add">
				<span
					@click="$router.push({ path: '/traveler',query:{templateId:orderList.templateId,type:0}})">+新增</span>
			</div>
			<div class="orderPopup-list">
				<ul>
					<li v-for="(item,index) in travelerList" :key="index" @click="selectTravelers(index)">
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_07.png"
							@click.stop="edit(item)" alt="">
						<!-- <p>{{item.templatTag[0].tagValue}}</p>
						<p>{{item.templatTag[1].tagValue}}</p> -->
						<p v-for="(map,sort) in item.templatTag" :key="sort" v-if="map.isMain">{{map.tagValue}}</p>
						<span class="orderPopup-lists">
							<img v-if="item.isSelect"
								src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_08.png"
								alt="">
							<font v-if="!item.isSelect" class="select-false"></font>
						</span>
					</li>
				</ul>
			</div>
		</van-popup>
		<!-- 联系人信息 -->
		<van-popup class="orderPopupt" v-model="orderContactShow" round position="bottom">
			<div class="orderPopup-sure">
				<span @click="orderContactShow = false">取消</span>
				<span @click="orderContactShow = false">确认</span>
			</div>
			<div class="orderPopup-list">
				<ul>
					<li v-for="(item,index) in travelerList" :key="index" @click="selecTorderContact(index)">
						<p v-for="(map,sort) in item.templatTag" :key="sort" v-if="map.isMain">{{map.tagValue}}</p>
						<span class="orderPopup-lists">
							<img v-if="item.checked"
								src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_08.png"
								alt="">
							<font v-if="!item.checked" class="select-false"></font>
						</span>
					</li>
				</ul>
			</div>
		</van-popup>
		<!-- 优惠券 -->
		<van-popup class="orderSaleshow" v-model="orderSaleshow" round position="bottom">
			<div class="orderSaleshow-sure">
				<img src="../../assets/pop_ico_close.png" alt="" @click="orderSaleshow = false">
				<h2>选择优惠券</h2>
			</div>
			<div class="orderSaleshow-coupon">
				<van-field v-model="input_coupon" placeholder="请输入优惠码" />
				<span @click="clickCouponChangeBtn">兑换</span>
			</div>
			<div class="orderSaleshow-content">
				<!-- tab -->
				<van-tabs v-model="active" class="orderSaleshow-content-tab">
					<van-tab title="可用" class="orderSaleshow-content-tabs">
						<img v-if="itemsLength < 1" src="../../assets/empty_ico_coupon.png" alt="">
						<div v-else class="orderSaleshow-list" v-for="(item,index) in couponList.items"
							@click="selectCoupon(item)">
							<div class="orderSaleshow-list-l">
								<span>
									<p>￥</p>
									<font>{{item.money}}</font>
								</span>
								<span>满{{item.fullMoney}}元可用</span>
							</div>
							<div class="orderSaleshow-list-r">
								<span>{{item.name}}</span>
								<span>有效期{{item.startUseDate}}</span>
							</div>
						</div>
					</van-tab>
					<van-tab title="不可用" class="orderSaleshow-content-tabs">
						<img v-if="noItemsLength < 1" src="../../assets/empty_ico_coupon.png" alt="">
						<div v-else class="orderSaleshow-list" v-for="(item,index) in couponList.noItems">
							<div class="orderSaleshow-list-l">
								<span>
									<p>￥</p>
									<font>{{item.money}}</font>
								</span>
								<span>满{{item.fullMoney}}元可用</span>
							</div>
							<div class="orderSaleshow-list-r">
								<span>{{item.name}}</span>
								<span>有效期{{item.startUseDate}}</span>
							</div>
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		_throttle
	} from '@/config/util'
	import {
		Dialog,
		Toast
	} from 'vant'
	export default {
		name: 'order',
		components: {
			BackTo
		},
		data() {
			return {
				active: 0,
				orderList: [],
				param: {},
				getTicketTel: "",
				getTicketName: "",
				getTicketCard: '',
				remark: "",
				show: false,
				expenseInclude: "",
				added: "",
				expenseNotInclude: "",
				travelerShow: false,
				travelerList: [],
				selectTravelerList: [],
				orderContactShow: false,
				orderSaleshow: false,
				input_coupon: '',
				select_coupon: null,
				couponList: [],
				noItemsLength: 0,
				itemsLength: 0
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			let param = JSON.parse(this.$route.query.orderParam);
			console.log(param)
			this.param = param
		},
		mounted() {
			this.getInfo()
			this.getTravelerList()
			this.clickCoupon()
		},
		methods: {
			submitOrder: _throttle(function(_type, index, item) {
				if (this.orderList.isTraveler) {
					if (this.selectTravelerList.length < this.param.number) {
						Toast('请补全出行人信息');
						return
					}
					this.sendOrder()
				} else {
					this.sendOrder()
				}
			}, 3000),
			sendOrder() {
				if (this.getTicketName == '') {
					Dialog.alert({
						message: '请填写联系人姓名',
					})
					return
				}

				if (this.getTicketTel == '') {
					Dialog.alert({
						message: '请填写联系人电话',
					})
					return
				}
				const toast = Toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: '提交中',
				});
				var arrs = []
				for (var j = 0; j < this.selectTravelerList.length; j++) {
					arrs.push(this.selectTravelerList[j].id)
				}

				let param = {
					'IsUserMember': false,
					"nearTravel_SKUEveryDayPriceId": this.param.calendarNative, //日历价格ID
					"quantity": this.param.number, //数量
					"userTemplateIds": arrs, //出行人ID
					"attnName": this.getTicketName, //联系人名
					"attnPhone": this.getTicketTel, //联系人手机号
					"attnID": this.getTicketCard, //,						//联系人身份证号
					"mark": this.remark, //备注
					"userId": this.userInfo.userId, //用户Id
					"merchant_OrganizationId": this.$organizationId, //平台
					"merchantId": "0", //分销商ID
					"source": 7,
					'ShareWebUserId': 0,
					"bigId": 0,
					"key": this.$md5(this.param.calendarNative + ',' + this.param.number + ',' + this.userInfo.userId +
						',' + this.getTicketTel + "|" + "@Sweet0ur2016-@Sweet0ur2024")
				}

				this.$_postNew(
					this.$severOrder + '/NTOrders/Post_PlaceAnOrderAsync', param
				).then(res => {
					if (res.success) {
						if (res.result.isSuccess) {
							if (this.select_coupon != null) {
								this.connectUserCoupon(res)
							} else {
								// 手动清除 Toast
								Toast.clear();
								this.$router.push({
									path: '/orderDetail',
									query: {
										orderId: res.result.id,
										orderType: this.$route.query.orderType
									}
								})
							}

						} else {
							Toast(res.result.msg)
							// 手动清除 Toast
							Toast.clear();
						}
					}
				})
			},
			connectUserCoupon(res_submit) {
				var param = {
					"CouponUserId": this.select_coupon.couponUserId,
					"productType": "NearTravel",
					"productId": this.param.proID,
					"skuId": this.param.skuid,
					"productName": this.param.proName,
					"orderPrice": this.param.payMoney,
					"useCouponPrice": this.select_coupon.useCouponPrice,
					"orderId": res_submit.result.id
				}
				this.$post(
					this.$connectHttpSweet + '/Coupon/APPUserUseCoupon', param
				).then(res => {
					if (res.isSuccess) {
						// 手动清除 Toast
						Toast.clear();
						this.$router.push({
							path: '/orderDetail',
							query: {
								orderId: res_submit.result.id
							}
						})
					} else {
						Toast(res.error)
					}
				})
			},
			selectCoupon(data) {
				this.select_coupon = data
				this.orderSaleshow = false
			},
			clickCouponChangeBtn() {
				this.$post(
					this.$activity + '/Coupon/UserGetCoupon', {
						"userId": this.userInfo.userId,
						"userName": this.userInfo.wxNick,
						"userPhone": this.userInfo.phone,
						"getType": 4,
						"couponCode": this.input_coupon
					}
				).then(res => {
					console.log(res)
					if (res.isSuccess) {
						Dialog.alert({
							message: '兑换成功',
						})
						this.orderSaleshow = false
					} else {
						Dialog.alert({
							message: res.error
						})
					}
				})

			},
			clickCoupon() {
				this.$post(
					this.$activity + '/Coupon/GetOrderCouponList', {
						"organizationId": this.$organizationId,
						"productType": "NearTravel",
						"productId": this.param.proID,
						"skuId": this.param.skuid,
						"orderPrice": this.param.payMoney,
						"userId": this.userInfo.userId
					}
				).then(res => {
					console.log(res)
					this.couponList = res
					this.noItemsLength = res.noItems.length
					this.itemsLength = res.items.length
				})
			},
			edit(e) {
				var data = JSON.stringify(e)
				this.$router.push({
					path: '/traveler',
					query: {
						templateId: this.orderList.templateId,
						type: 1,
						object: data
					}
				})
			},
			travelerCancel() {
				this.travelerShow = false
				for (let i = 0; i < this.travelerList.length; i++) {
					this.travelerList[i].isSelect = false
				}
			},
			travelerTrue() {
				this.travelerShow = false
				this.selectTravelerList = this.travelerList.filter(item => item.isSelect == true)
			},
			selectTravelers(e) {
				var selectLength = this.travelerList.filter(item => item.isSelect == true)
				if (selectLength.length < this.param.number) {
					this.travelerList[e].isSelect = !this.travelerList[e].isSelect
				} else {
					var index = this.travelerList.findIndex(item => item.isSelect == true)
					this.travelerList[index].isSelect = !this.travelerList[index].isSelect
					this.travelerList[e].isSelect = !this.travelerList[e].isSelect
				}
			},
			selecTorderContact(e) {
				console.log(this.travelerList)
				var selectLength = this.travelerList.filter(item => item.checked == true)
				if (selectLength < 1) {
					this.travelerList[e].checked = !this.travelerList[e].checked
				} else {
					var index = this.travelerList.findIndex(item => item.checked == true)
					this.travelerList[index].checked = !this.travelerList[index].checked
					this.travelerList[e].checked = !this.travelerList[e].checked
				}
				this.getTicketTel = this.travelerList[e].templatTag.filter(item => item.tagName ==
					'手机号')[0].tagValue
				this.getTicketName = this.travelerList[e].templatTag.filter(item => item.tagName ==
					'姓名')[0].tagValue
				this.getTicketCard = this.travelerList[e].templatTag.filter(item => item.tagName ==
					'身份证号' || item.tagName == '证件号')[0].tagValue
			},
			selectTravelersD(e) {
				for (let i = 0; i < this.travelerList.length; i++) {
					this.travelerList[i].isSelect = false
				}
				this.selectTravelerList.splice(e, 1)
			},
			getTravelerList() {
				this.$_getNew(
					this.$severOrder + '/Order_UserTemplateBase/GetByUserId?Id=' + this.userInfo.userId, {}
				).then(res => {
					for (let i = 0; i < res.result.length; i++) {
						res.result[i].isSelect = false
						res.result[i].checked = false
					}
					this.travelerList = res.result
				})
			},
			getInfo() {
				this.$_getNew(
					this.$severOrder + '/NTOrders/Get_PlaceAnOrderPrepAsync?id=' + this.param.calendarNative, {}
				).then(res => {
					this.orderList = res.result
					this.expenseInclude = res.result.nearTravel_TicketConfig == null ? '' : res.result
						.nearTravel_TicketConfig.expenseInclude
					this.added = res.result.nearTravel_TicketConfig == null ? '' : res.result
						.nearTravel_TicketConfig.added
					this.expenseNotInclude = res.result.nearTravel_TicketConfig == null ? '' : res.result
						.nearTravel_TicketConfig.expenseNotInclude
				})
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		}
	}
</script>

<style>
	.order {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.orderCommon {
		background-color: #fff;
		border-radius: 24px;
		width: 100%;
		padding: 0 30px 30px 30px;
		box-sizing: border-box;
		margin-bottom: 30px;
		font-size: 28px;
	}

	.orderInfo {
		width: 100%;
		color: #333;
	}

	.orderCommon h2 {
		font-size: 30px;
		line-height: 80px;
		font-weight: bold;
	}

	.orderInfo span {
		display: flex;
		align-items: center;
		font-size: 28px;
		margin-top: 16px;
	}

	.orderInfo span p {
		padding-right: 14px;
	}

	.orderNum-t {
		display: flex;
		align-items: center;
		justify-content: space-between;
		line-height: 80px;
		height: 80px;
	}

	.orderNum-t p:last-child {
		font-weight: bold;
	}

	.orderNum-x {
		font-size: 24px;
		color: #409bff;
		margin-top: 30px;
	}

	.contact_mes {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 28px;
		color: #333;
	}

	.contact_mes font,
	.orderTravel-p span:last-child {
		width: 168px;
		height: 46px;
		color: #fff;
		font-size: 28px;
		background: #ff6d00;
		border: none;
		outline: none;
		border-radius: 8px;
		line-height: 46px;
		text-align: center;
	}

	.orderContact-text {
		width: 100%;
		margin-top: 30px;
	}

	.orderContact-text .van-cell {
		padding: 20px 0;
	}

	.orderContact-text .van-cell::after {
		border: 0;
	}

	.orderContact-text .van-cell__title {
		width: 150px;
		color: #333;
	}

	.orderSale-sale {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.coupon-value {
		display: flex;
		align-items: center;
		color: #999999;
	}

	.orderMessage {
		margin-bottom: 120px;
	}

	.orderMessage-remark {
		width: 100%;
	}

	.orderMessage-remark .van-cell {
		padding: 0;
		height: 300px;
	}

	.orderMessage-remark .van-field--min-height .van-field__control {
		height: 240px;
	}

	.orderBottom {
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #fff;
		width: 100%;
		height: 96px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.orderBottom span {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 96px;
		flex: 1;
	}

	.orderBottom span:last-child {
		background: #ff6d00;
		font-size: 40px;
		color: #fff;
	}

	.orderBottom span:first-child {
		color: #ff6d00;
		font-display: 36px;
	}

	.orderPopup {
		width: 100%;
		padding: 30px 70px;
		box-sizing: border-box;
	}

	.alertTitle {
		font-size: 32px !important;
		color: #333;
		text-align: center;
		width: 100%;
		font-weight: normal;
	}

	.popup {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.popup img {
		width: 32px;
		height: 32px;
	}

	.popup_title_1 {
		display: flex;
		align-items: center;
		font-size: 28px;
		color: #409bff;
		margin-bottom: 10px;
		margin-top: 30px;
	}

	.popup_title_1 p {
		margin-left: 10px;
	}

	.orderPopup-text {
		font-size: 26px;
		color: #999;

	}

	.color01 {
		color: #ff6d00;
	}

	.color02 {
		color: #ff5964;
	}

	.orderTravel-p {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 24px;
		color: #999;
		margin-top: 20px;
	}

	.orderTravel-p span:first-child {
		display: flex;
		align-items: center;
	}

	.orderTravel-p p {
		color: #ff6d00;
	}

	.orderPopupt {
		width: 100%;
		padding: 30px 0;
		height: 600px;
	}

	.orderPopup-sure {
		display: flex;
		justify-content: space-between;
		width: 100%;
		font-size: 30px;
		border-bottom: 1px solid #f2f2f2;
		padding: 0 70px 30px 70px;
		box-sizing: border-box;
	}

	.orderPopup-sure span:first-child {
		color: #ccc;
	}

	.orderPopup-sure span:last-child {
		color: #ff6d00;
	}

	.orderPopup-add {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.orderPopup-add span {
		margin-top: 30px;
		background: #f5f5f5;
		height: 80px;
		font-size: 40px;
		color: #ff6d00;
		text-align: center;
		line-height: 80px;
		border-radius: 5px;
		width: 100%;
	}

	.orderPopup-list {
		width: 100%;
		padding: 10px 50px;
		box-sizing: border-box;
	}

	.orderPopup-list li {
		display: flex;
		align-items: center;
		border-bottom: #f5f5f5 solid 1px;
		font-size: 30px;
		color: #333;
		height: 100px;

	}

	.orderPopup-list li p {
		margin-left: 30px;
	}

	.orderPopup-list img {
		width: 28px;
		height: 28px;
	}

	.select-false {
		display: block;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 1px solid #666;
		box-sizing: border-box;
	}

	.orderPopup-lists {
		margin-left: auto;
	}

	.orderTravel-c {
		width: 100%;
		margin-top: 20px;
	}

	.orderTravel-c li {
		display: flex;
		align-items: center;
		border-top: 1px solid #f5f5f5;
		box-sizing: border-box;
		height: 80px;
		display: flex;
		align-items: center;
	}

	.orderTravel-c li:first-child {
		border: 0;
	}

	.orderTravel-c li p {
		margin-left: 40px;
		font-size: 28px;
		color: #333;
	}

	.orderTravel-c img {
		width: 36px;
		height: 36px;
	}

	.orderSaleshow {
		width: 100%;
		height: 800px;
		background-color: #f5f5f5;
	}

	.orderSaleshow-sure {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		padding: 28px 28px 40px 28px;
		box-sizing: border-box;
		background-color: #fff;
	}

	.orderSaleshow-sure h2 {
		font-weight: normal;
		color: #36393E;
		font-size: 32px;
	}

	.orderSaleshow-sure img {
		position: absolute;
		left: 28px;
		width: 45px;
		height: 45px;
	}

	.orderSaleshow-coupon {
		width: 100%;
		display: flex;
		width: 100%;
		background: #fafafa;
		align-items: center;
		box-sizing: border-box;
		justify-content: space-between;
		padding: 0 24px;
		box-sizing: border-box;
	}

	.orderSaleshow-coupon .van-cell {
		background-color: #fafafa;
	}

	.orderSaleshow-coupon .van-cell::after {
		border: 0;
	}

	.orderSaleshow-coupon span {
		box-sizing: border-box;
		width: 115px;
		height: 52px;
		background: #FF7A09;
		border-radius: 10px;
		font-size: 24px;
		line-height: 52px;
		text-align: center;
		color: #fff;
	}

	.orderSaleshow-content {
		/* margin-top: 20px; */
	}

	.orderSaleshow-content-tab img {
		width: 408px;
		height: 315px;
		margin-top: 50px;
	}

	.orderSaleshow-content-tabs {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 28px;
		box-sizing: border-box;
		width: 100%;
	}

	.orderSaleshow-list {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #fff;
		border-radius: 20px;
		height: 150px;
		margin-bottom: 20px;
	}

	.orderSaleshow-list div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.orderSaleshow-list-l {
		width: 35%;
	}

	.orderSaleshow-list-l span:first-child {
		display: flex;
		font-weight: bold;
		color: #F94C00;
	}

	.orderSaleshow-list-l span:first-child p {
		margin-top: 25px;
		font-size: 28px;
	}

	.orderSaleshow-list-l span:first-child font {
		font-size: 50px;
	}

	.orderSaleshow-list-l span:last-child {
		font-size: 22px;
		font-weight: 400;
		color: #F94C00;
	}

	.orderSaleshow-list-r {
		width: 65%;
	}

	.orderSaleshow-list-r span:first-child {
		font-size: 30px;
		font-weight: bold;
		color: #333333;
		display: inline-block;
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.orderSaleshow-list-r span:last-child {
		margin-top: 16px;
		font-size: 22px;
		font-weight: 400;
		color: #999999;
		display: inline-block;
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>